var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy"},[_c('Header',{attrs:{"title":"Personvern og cookies","description":"Her finner du en oversikt over hvilke informasjonskapsler NetsGo benytter og formålet de benyttes til"}}),_c('Privacy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }